$(() => {
  // Define these changes separately because we only want them to fire when product options
  // are clicked. We don't want them firing on every pageload.
  const toggle_dependencies = (dependencies) => {
    const fade = 400;
    const ss = $('#product-ss-checkbox').is(':checked');
    const ta = $('#product-ta-checkbox').is(':checked');
    const cc = $('#product-cc-checkbox').is(':checked');

    if (ss === true) {
      $('.benefit-detail-ss').slideDown(fade);
    } else {
      $('.benefit-detail-ss').slideUp(fade);
    }

    if (ta === true) {
      $('#payroll-noncompliance-penalty-wrapper').slideDown(fade);
      $('.benefit-detail-ta').slideDown(fade);
    } else {
      $('#payroll-noncompliance-penalty-wrapper').slideUp(fade);
      $('.benefit-detail-ta').slideUp(fade);
    }

    if (cc === true) {
      $('#number-of-beds-wrapper').slideDown(fade);
      $('.benefit-detail-cc').slideDown(fade);
      $('#time-communicating-about-care-wrapper').slideDown(fade);
      $('#physicians-on-staff-wrapper').slideDown(fade);
      $('#nurses-on-staff-wrapper').slideDown(fade);
      $('#pagers-in-use-wrapper').slideDown(fade);
      $('#monthly-cost-per-pager-wrapper').slideDown(fade);
      $('#avg-cost-per-day-wrapper').slideDown(fade);
      $('#patient-discharges-per-year-wrapper').slideDown(fade);
      $('#annual-physician-salary-wrapper').slideDown(fade);
      $('#annual-nurse-salary-wrapper').slideDown(fade);
      $('#cc-license-fee-wrapper').slideDown(fade);
      $('#cc-implementation-fee-wrapper').slideDown(fade);
      $('#grow-protect-revenue').slideDown(fade);
    } else {
      $('#number-of-beds-wrapper').slideUp(fade);
      $('.benefit-detail-cc').slideUp(fade);
      $('#time-communicating-about-care-wrapper').slideUp(fade);
      $('#physicians-on-staff-wrapper').slideUp(fade);
      $('#nurses-on-staff-wrapper').slideUp(fade);
      $('#pagers-in-use-wrapper').slideUp(fade);
      $('#monthly-cost-per-pager-wrapper').slideUp(fade);
      $('#avg-cost-per-day-wrapper').slideUp(fade);
      $('#patient-discharges-per-year-wrapper').slideUp(fade);
      $('#annual-physician-salary-wrapper').slideUp(fade);
      $('#annual-nurse-salary-wrapper').slideUp(fade);
      $('#cc-license-fee-wrapper').slideUp(fade);
      $('#cc-implementation-fee-wrapper').slideUp(fade);
      $('#grow-protect-revenue').slideUp(fade);
    }

    if (ss === true || ta === true) {
      $('#fte-on-payroll-team-wrapper').slideDown(fade);
      $('#annual-labor-expense-wrapper').slideDown(fade);
      $('#avg-time-on-staffing-and-scheduling').slideDown(fade);
      $('#fte-managing-staffing-wrapper').slideDown(fade);
      $('#annual-payroll-mgr-salary-wrapper').slideDown(fade);
      $('#annual-staffing-mgr-salary-wrapper').slideDown(fade);
      $('#wfm-implementation-fee-wrapper').slideDown(fade);
      $('#wfm-license-fee-wrapper').slideDown(fade);
    } else {
      $('#fte-on-payroll-team-wrapper').slideUp(fade);
      $('#annual-labor-expense-wrapper').slideUp(fade);
      $('#avg-time-on-staffing-and-scheduling-wrapper').slideUp(fade);
      $('#fte-managing-staffing-wrapper').slideUp(fade);
      $('#annual-payroll-mgr-salary-wrapper').slideUp(fade);
      $('#annual-staffing-mgr-salary-wrapper').slideUp(fade);
      $('#wfm-implementation-fee-wrapper').slideUp(fade);
      $('#wfm-license-fee-wrapper').slideUp(fade);
    }

    // Benefit 1
    if (ss === true || ta === true) {
      $('.reduce-labor-expenses').slideDown(fade);
    } else {
      $('.reduce-labor-expenses').slideUp(fade);
    }

    // Benefit 2
    if (ta === true && ($('.self-service').length === 0)) {
      $('.avoid-payroll-penalty').slideDown(fade);
    } else {
      $('.avoid-payroll-penalty').slideUp(fade);
    }

    // Benefit 3
    if (ss === true || ta === true) {
      $('.increase-payroll-team-capacity').slideDown(fade);
    } else {
      $('.increase-payroll-team-capacity').slideUp(fade);
    }

    // Benefit 4
    if (ss === true || ta === true) {
      $('.reduce-time-on-schedules').slideDown(fade);
    } else {
      $('.reduce-time-on-schedules').slideUp(fade);
    }

    // Benefit 5
    if (cc === true) {
      $('.reduce-time-communicating').slideDown(fade);
    } else {
      $('.reduce-time-communicating').slideUp(fade);
    }

    // Benefit 6
    if (cc === true) {
      $('.reduce-communication-system-spend').slideDown(fade);
    } else {
      $('.reduce-communication-system-spend').slideUp(fade);
    }

    // Benefit 7
    if (cc === true) {
      $('.reduce-length-of-stay').slideDown(fade);
    } else {
      $('.reduce-length-of-stay').slideUp(fade);
    }

    // Benefit 8
    if (ss === true || ta === true || cc === true) {
      $('.improve-retention').slideDown(fade);
    } else {
      $('.improve-retention').slideUp(fade);
    }

    // Benefit 9
    if (cc === true) {
      $('.improve-pt-outcomes').slideDown(fade);
    } else {
      $('.improve-pt-outcomes').slideUp(fade);
    }
  };

  const set_impact_variables = () => {
    const ss = $('#product-ss-checkbox').is(':checked');
    const ta = $('#product-ta-checkbox').is(':checked');
    const cc = $('#product-cc-checkbox').is(':checked');

    // Benefit 1
    if (ss === true && ta === true) {
      $('#percent-reduction-in-labor-expenses').val(1);
    } else if (ss === false || ta === false) {
      $('#percent-reduction-in-labor-expenses').val(0.5);
    }

    // Benefit 3
    if (ss === true && ta === true) {
      $('#percent-increase-in-payroll-team-capacity').val(75);
    } else if (ss === true) {
      $('#percent-increase-in-payroll-team-capacity').val(25);
    } else if (ta === true) {
      $('#percent-increase-in-payroll-team-capacity').val(50);
    }

    // Benefit 4
    if (ss === true && ta === true) {
      $('#percent-reduction-in-time-on-schedules').val(50);
    } else if (ss === false || ta === false) {
      $('#percent-reduction-in-time-on-schedules').val(25);
    }

    // Benefit 8
    let impact = 0;
    if (ss === true) {
      impact += 0.33;
    }
    if (ta === true) {
      impact += 0.33;
    }
    if (cc === true) {
      impact += 0.33;
    }
    $('#percent-improvement-in-retention').val(impact);
  };

  $('.product-options').click(() => {
    set_impact_variables();
    toggle_dependencies();
  });

  toggle_dependencies();
});
